import React from "react";
import { formatMessage } from "lib/globalize-util";
import { AlertDialog } from "components/dialog/alert";
import { ExportCollection } from "../product-collection-header-components/export-collection";
import { IAllocationDimension } from "helpers/allocation-dimension";
import { GridApi } from "ag-grid-community";
import { IExportParams } from "constants/product-collection";

interface IProps {
    onClose: () => void;
    onExport: (params: IExportParams) => void;
    gridApi: GridApi;
    allocationDimensions: IAllocationDimension[];
    collectionExport;
    isCloseoutAssortmentEnabled?: boolean;
}

const ProductCollectionExportDialog: React.FunctionComponent<IProps> = ({
    onExport,
    onClose,
    gridApi,
    allocationDimensions,
    collectionExport,
    isCloseoutAssortmentEnabled,
}) => {
    return (
        <AlertDialog
            dismissButton={false}
            onRequestClose={onClose}
            open={true}
            title={formatMessage("Export Assortment")}
            contentStyle={{ maxWidth: "600px" }}
        >
            <ExportCollection
                gridApi={gridApi}
                allocationDimensions={allocationDimensions}
                collectionExport={collectionExport}
                onCloseExportDialog={onClose}
                onExport={onExport}
                isCloseoutAssortmentEnabled={isCloseoutAssortmentEnabled}
            />
        </AlertDialog>
    );
};

export { ProductCollectionExportDialog };
